module.exports = __webpack_public_path__ + "static/Productivity-6e335abf794389a1dd7ca41f611b3291.png";